import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { makeServer } from './server';
import { createRoot } from 'react-dom/client';

/** CSS Imports */
import './index.css';

if (process.env.NODE_ENV === 'development') {
	makeServer({ environment: 'development' });
}

const root = createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<Router>
			<App />
		</Router>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
